import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "src/components/ui/button";
import { BaseUrlApi, ErrorMessage } from "src/lib/api";
import { Select } from "antd";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "src/components/ui/sheet";
import { Input } from "src/components/ui/input";
import {
  Select as SelectUi,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "src/components/ui/select";

export const TransactionAddSheet = ({
  handleFetchTransactions,
  users,
  loadingUsers,
}) => {
  const [showAddSheet, setShowAddSheet] = useState(false);

  const [addRecord, setAddRecord] = useState({
    user_id: null,
    type: "bonus",
    amount: 0,
    reason: "",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      // Use your appropriate API endpoint for bonus records
      await axios.post(`${BaseUrlApi}/transactions`, addRecord);
      toast("تمت الإضافة", {
        description: "تمت إضافة المعاملة بنجاح 🎉",
      });
      await handleFetchTransactions();
      setShowAddSheet(false);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object")
        toast("Error", {
          description: result,
        });
      setErrors(result);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Sheet open={showAddSheet} onOpenChange={setShowAddSheet}>
      <SheetTrigger asChild>
        <Button disabled={loadingUsers}>إضافة معاملة</Button>
      </SheetTrigger>
      <SheetContent side="left" dir="rtl">
        <SheetHeader className="text-start">
          <SheetTitle>إضافة معاملة جديدة</SheetTitle>
        </SheetHeader>
        <div className="space-y-4 mt-3">
          {/* User ID */}
          <div className="space-y-2">
            <label className="block font-medium mb-1">اختر عضو</label>
            <Select
              placeholder="اختر عضو"
              value={addRecord.user_id}
              onChange={(e) => setAddRecord({ ...addRecord, user_id: e })}
              style={{ width: "100%" }}
              options={users.map((user) => ({
                value: user.id,
                label: user.name,
              }))}
              // These are the key properties to fix touchability in Sheet
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              dropdownStyle={{ zIndex: 9999 }}
              virtual={false}
            />
            {errors?.user_id && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.user_id[0]}
              </p>
            )}
          </div>

          {/* Type */}
          <div className="space-y-2">
            <label className="block font-medium">النوع</label>
            <SelectUi
              value={addRecord.type}
              onValueChange={(e) => setAddRecord({ ...addRecord, type: e })}
            >
              <SelectTrigger className="rounded-lg" aria-label="اختر النوع" dir="rtl">
                <SelectValue placeholder="اختر النوع" />
              </SelectTrigger>
              <SelectContent className="rounded-xl">
                <SelectItem value="bonus" className="rounded-lg">
                  Bonus
                </SelectItem>
              </SelectContent>
            </SelectUi>
            {errors?.type && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.type[0]}
              </p>
            )}
          </div>

          {/* Amount */}
          <div className="space-y-2">
            <label className="block font-medium">المبلغ</label>
            <Input
              type="number"
              step="0.01"
              className="w-full p-2 border rounded mt-1"
              value={addRecord.amount}
              onChange={(e) =>
                setAddRecord({
                  ...addRecord,
                  amount: parseFloat(e.target.value),
                })
              }
            />
            {errors?.amount && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.amount[0]}
              </p>
            )}
          </div>

          {/* Reason */}
          <div className="space-y-2">
            <label className="block font-medium">السبب</label>
            <textarea
              className="w-full p-2 border rounded mt-1"
              placeholder="أدخل سبب الدفع"
              value={addRecord.reason}
              onChange={(e) =>
                setAddRecord({ ...addRecord, reason: e.target.value })
              }
            />
            {errors?.reason && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.reason[0]}
              </p>
            )}
          </div>

          <div className="text-end">
            <Button onClick={handleAdd} disabled={loading}>
              {loading ? "جاري الإضافة..." : "إضافة"}
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
